import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {Panel, PANEL_COLORS, PANEL_ROUNDED} from '@adv-mt/ui/panel'

import ContactActions from '../ContactActions/index.js'
import PhoneAction from '../ContactActions/PhoneAction.js'
import ContactForm from '../ContactForm/index.js'
import {
  ContactCardInputProvider,
  ContactCardStateProvider,
  ContactSellerV2ConfigProvider,
  pickContactSellerV2Config
} from '../context/ContactSellerV2Context.js'
import {contactCardV2PropTypes, FORM_PRESENTATIONS} from '../contracts.js'
import {isPrivateSellerContract} from '../helpers/sellerType.js'
import SellerInfo from '../SellerInfo/index.js'

export const BASE_CLASS = 'mt-ContactCardV2'
export const INSET_CLASS = `${BASE_CLASS}-inset`

const ContactCardV2 = props => {
  const {domain} = useContext(Context)
  const {PRIVATE_CONTRACT_ID} = domain.get('config').get('dealer')
  const isPrivateSeller = isPrivateSellerContract({
    contractId: props.contractId,
    privateContractId: PRIVATE_CONTRACT_ID,
    whenMissingContractId: false
  })
  const isPrivateSellerWithoutPhone = isPrivateSeller && props.hidePhone

  return (
    <ContactSellerV2ConfigProvider value={{...pickContactSellerV2Config(props), isPrivateSeller}}>
      <ContactCardInputProvider value={props}>
        <ContactCardStateProvider
          initialSelection={props.buyerIntentionsSelection}
          onBuyerIntentionsChange={props.onBuyerIntentionsChange}
        >
          <Panel border className={BASE_CLASS} color={PANEL_COLORS.BASE} rounded={PANEL_ROUNDED.L}>
            <div className={INSET_CLASS}>
              <SellerInfo />
              <ContactForm
                buttonGroup={
                  props.formPresentation === FORM_PRESENTATIONS.DRAWER && !isPrivateSellerWithoutPhone ? (
                    <PhoneAction iconOnlyCapable={false} isInDrawer />
                  ) : undefined
                }
              />
              <ContactActions />
            </div>
            {props.canariasBanner}
          </Panel>
        </ContactCardStateProvider>
      </ContactCardInputProvider>
    </ContactSellerV2ConfigProvider>
  )
}

ContactCardV2.displayName = 'ContactCardV2'

ContactCardV2.propTypes = contactCardV2PropTypes

export default ContactCardV2
